import {AfterViewInit, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'component-questionnaire-title',
  templateUrl: './component.questionnaire-title.html',
  styleUrls: ['./component.questionnaire-title.css']
})
export class ComponentQuestionnaireTitle implements OnInit, AfterViewInit {
  @Input() questionnaireTitle: string;

  constructor() {}

  ngOnInit() {


  }

  ngAfterViewInit(){

  }


}



// WEBPACK FOOTER //
// ./src/component/questionnire/child-title/component.questionnaire-title.ts